// extracted by mini-css-extract-plugin
export default {"image":"aX-z","loaded":"bX-z"};